<template>
  <div class="content-scroll">
    <div class="content-box page">
      <el-tabs active-name="first" class="pageTitle">
        <el-tab-pane label="经销商列表" name="first"></el-tab-pane>
      </el-tabs>
      <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus" title="新增">新增</el-button>

      <el-form ref="form" :inline="true" :model="filters" size="small">
        <el-form-item label="搜索条件" prop="company">
          <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
        </el-form-item>
        <el-form-item label="授权时间">
          <el-date-picker size="small" v-model="timeRange" @change="getTimeRange($event,'startTime','endTime')" type="daterange" range-separator="-" start-placeholder="申请开始日期" end-placeholder="申请结束日期" align="right"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="el-icon-download" type="primary" @click="handleExport()">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="el-icon-download" type="danger" @click="handleExportTemplate()">模板下载</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
              ref='import'
              :action="root + uploadUrl"
              :show-file-list="false"
              :on-success="importSuccess"
              :before-upload="beforeImportFile"
              :on-error="handleError"
              :headers="{'username': username }">
            <el-button size="small" type="warning">经销商导入</el-button>
          </el-upload>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
        <el-table-column prop="nbr" label="序号" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="company" label="公司"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="country" label="国家"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="communication" label="主要沟通方式"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="isSgin" label="是否签授权书" :formatter="signFormatter"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="products" label="授权产品"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="startTime" label="授权开始时间" align="center" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="endTime"  label="授权结束时间" align="center" ></el-table-column>
        <el-table-column label="操作" width="150" align="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)" icon="el-icon-edit"></el-button>
            <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <div class="toolbar" style="text-align: right;">
        <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"  :page-size="filters.pageSize" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
      </div>

      <!--新增界面-->
      <el-dialog :title="saveType ? '经销商编辑':'经销商新增'" :visible.sync="aVisible" width="50%" :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
        <el-form :model="formData" :rules="formRules" label-width="120px" ref="formFileds" size="small">
          <el-form-item label="客户：" prop="customerId" class="w450">
            <el-button size="small" :type="formData.customerId ? '' : 'primary'" @click="cVisible = true">{{ formData.customerId ? '已选择Id(' + formData.customerId + ')' : '选择客户'}}</el-button>
          </el-form-item>
          <el-form-item label="公司名称" prop="company" class="w350">
            <el-input clearable v-model="formData.company"></el-input>
          </el-form-item>
          <el-form-item label="国家" prop="country" class="w350">
            <el-input clearable v-model="formData.country"></el-input>
          </el-form-item>
          <el-form-item label="主要沟通方式" prop="contact" class="w350">
            <el-input clearable v-model="formData.communication"></el-input>
          </el-form-item>
          <el-form-item label="是否签授权书" prop="content" class="w350">
            <el-select clearable size="small"  @change="changeValue($event)" v-model="formData.isSign" placeholder="请选择">
              <el-option label="已签授" :value="1"></el-option>
              <el-option label="未签授" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权产品" prop="contact" class="w350">
            <el-input clearable v-model="formData.products"></el-input>
          </el-form-item>
          <el-form-item label="授权开始日期" v-show="showTime" class="w700" prop="startTime" >
              <el-date-picker :picker-options="pickerBeginDateBefore"  v-model="formData.startTime" placeholder="年-月-日" value-format="yyyy-MM-dd"/>
          </el-form-item>
          <el-form-item label="授权结束日期" class="w700" v-show="showTime" prop="endTime">
            <el-date-picker :picker-options="pickerBeginDateAfter" v-model="formData.endTime" placeholder="年-月-日" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item>
            <el-button @click.native="aVisible = false">取消</el-button>
            <el-button type="primary" @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)" :loading="bLoading">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog :visible.sync="cVisible" width="1300px" :modal-append-to-body="true" :close-on-click-modal="false" top="5%">
        <div class="solt-header">
          <h2>客户选择</h2>
        </div>
        <customer-list v-if="cVisible" @material="setMaterial"></customer-list>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomerList from '@/components/CustomerList.vue'
export default {
  components:{
    CustomerList,
  },
  data() {
    return {
      pageUrl:'/customer/dealer/list/page',
      updateUrl:'/customer/dealer/saveOrUpdate',
      addUrl:'/customer/dealer/saveOrUpdate',
      deleteUrl:'/customer/dealer/remove',
      exportUrl:'/customer/dealer/export',
      exportTemplateUrl:'/customer/dealer/exportTemplate',
      importUrl:'/customer/dealer/import',
      filters:{
        pageSize: 10,
        pageIndex: 1,
        customerId: null,
        company:'',
        startTime:'',
        endTime:'',
      },
      pickerBeginDateBefore: {
        disabledDate: (time) => {
          const beginDateVal = new Date(this.formData.endTime).getTime()
          if (beginDateVal) {
            return time.getTime() > beginDateVal
          }
        }
      },
      pickerBeginDateAfter: {
        disabledDate: (time) => {
          const beginDateVal = new Date(this.formData.startTime).getTime()
          if (beginDateVal) {
            return time.getTime() <= beginDateVal - 86400000
          }
        }
      },
      formData:{
        customerId:'',
        company:'',
        communication:'',
        country:'',
        isSign:0,
        products:'',
        startTime:'',
        endTime:'',
        id:'',
      },
      formRules: {
        customerId: [
          { required: true, message: '请选择客户', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
      },
      showTime:true
    }
  },
  computed:{
    ...mapGetters(['username'])
  },
  methods: {
    changeValue(v) {
      if(v===0){
        this.showTime = false;
        this.formData.startTime = '';
        this.formData.endTime = '';
      }else{
        this.showTime = true;
      }
      },
    signFormatter(row,column) {
      if(row.isSign == 0) {
        return "未签授"
      }
      if(row.isSign == 1) {
        return "已签授"
      }
    },
    setMaterial(row){
      this.cVisible = false;
      this.formData.customerId = row.id;
      row.id = this.formData.id;
      this.mergeObject(this.formData, row)
    },
  },
  mounted(){
    this.filters.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
    this.formData.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
    this.getPage()
  }
}
</script>